/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/firstRunPushPrompt.scss';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {SnoozeConfig} from '../../../util/snoozeUtil';
import {BluemateDialog} from '../../controls';

interface Props {
    active: boolean;
    loading: boolean;
    snooze: SnoozeConfig;
    onConfirm: VoidFunction;
    onCancel: VoidFunction;
}

export default function FirstRunPushPrompt(props: Props) {
    const {t} = useTranslation();
    const {active, loading, snooze, onConfirm, onCancel} = props;

    return (
        <BluemateDialog
            active={active}
            onClose={onCancel}
            snooze={{...snooze, dismissOnClose: false}}
            title={t('push.firstRun.title', 'Meldingen op deze telefoon')}
            className='first-run-push-prompt'
            width='32rem'
            onConfirm={onConfirm}
            confirmLabel={t('push.firstRun.yes', 'Ja')}
            onCancel={onCancel}
            cancelLabel={t('push.firstRun.later', 'Misschien later')}
            cancelVariant='tertiary'
            loading={loading}
        >
            <p className='message'>{t('push.firstRun.body', 'Wil je pushmeldingen ontvangen op deze telefoon?')}</p>
            <p className='settings-hint'>
                {t(
                    'push.firstRun.settingsHint',
                    'Je kunt pushmeldingen later altijd nog inschakelen via je meldingsinstellingen.'
                )}
            </p>
        </BluemateDialog>
    );
}
